module.exports = __webpack_public_path__ + "media/images/illustrations/academic-coaching-a138e0d1ae5762723c19509a9c5f6150.svg";